import { deepGet } from "./objectHelpers";

export const getResponseErrorMessage = error => {
  const modelState = deepGet(error, ["response", "data", "ModelState"]);
  if (modelState) {
    return Object.keys(modelState)
      .map(key => modelState[key])
      .join(", ");
  }

  return deepGet(
    error,
    ["response", "data", "Message"],
    "Error occurred during processing your request."
  );
};



// WEBPACK FOOTER //
// ./src/utils/httpHelpers.js